module.exports = __webpack_public_path__ + "static/img/halifax2.d1bcb60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/halifax2.jpg
// module id = 94
// module chunks = 9